import { Injectable, Renderer2 } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormFocusInvalidFieldService {
  private renderer!: Renderer2;
  private form!: FormGroup;

  public setForm(
    formToCheck: FormGroup | undefined,
    renderer: Renderer2
  ): FormFocusInvalidFieldService {
    if (formToCheck) {
      this.form = formToCheck;
    }

    this.renderer = renderer;

    return this;
  }

  public validateFields(): void {
    if (!this.form.valid) {
      const invalidField = Object.keys(this.form.controls).find(
        (field) => this.form.controls[field].invalid
      );

      if (invalidField) {
        this.form.get(invalidField)?.markAsTouched();

        const element = this.renderer.selectRootElement(
          `[formControlName="${invalidField}"], [controlName="${invalidField}"]`,
          true
        );

        element.parentElement.scrollIntoView();
        element.focus();
      }
    }
  }
}
